import React from 'react';
import { Box, Typography } from '@mui/material';
import { Schedule as FeeScheduleIcon } from '@mui/icons-material';
import { SaveFeeScheduleButton, CancelFeeScheduleButton, DeleteFeeScheduleButton } from '../../commands';

interface FeeScheduleEditHeaderProps {
  company: string;
  isDirty: boolean;
}

const FeeScheduleEditHeader: React.FC<FeeScheduleEditHeaderProps> = ({ 
  company, 
  isDirty
}) => (
  <Box sx={{ 
    backgroundColor: '#ffffff',
    borderBottom: '2px solid #3b82f6',
    p: 2.5,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <FeeScheduleIcon sx={{ fontSize: 32, color: '#3b82f6' }} />
      <Box>
        <Typography 
          variant="h5" 
          sx={{ 
            fontWeight: 600, 
            color: '#1e293b',
            mb: 0.5
          }}
        >
          Edit Fee Schedule
        </Typography>
        <Typography 
          variant="body2" 
          sx={{ color: '#64748b' }}
        >
          {company} | Fee Schedule Edit
          {isDirty && (
            <Typography 
              component="span" 
              sx={{ ml: 2, color: 'warning.main', fontSize: 'inherit' }}
            >
              • Unsaved Changes
            </Typography>
          )}
        </Typography>
      </Box>
    </Box>

    <Box sx={{ display: 'flex', gap: 2 }}>
      <DeleteFeeScheduleButton />
      <CancelFeeScheduleButton />
      <SaveFeeScheduleButton />
    </Box>
  </Box>
);

export default FeeScheduleEditHeader;
